const sortByMostRecentDate = (aDateStr: string, bDateStr: string) => {
	return new Date(bDateStr).getTime() - new Date(aDateStr).getTime();
};

export default sortByMostRecentDate;
